import { render, staticRenderFns } from "./CaseEditor.vue?vue&type=template&id=4b289c3a&"
import script from "./CaseEditor.vue?vue&type=script&lang=ts&"
export * from "./CaseEditor.vue?vue&type=script&lang=ts&"
import style0 from "./CaseEditor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports